/* eslint-disable no-console */
import { getCookie, setCookieToExpireOnDate } from '../utils/cookie-utils';

const originCookie = () => {
  const COOKIE_NAME = 'sst-origin';
  if (getCookie(COOKIE_NAME) === '') {
    const date = new Date('Mar 31 2023 11:59:59 GMT'); // Set expire on March 31, 223, at 11:59pm GMT
    setCookieToExpireOnDate(COOKIE_NAME, 'B', date);
  }
};

export default originCookie;
/* eslint-enable no-console */
